import {useCallback, useState} from 'react';

import type {DiagramFilters} from '../CarDiagram.types';

const DEFAULT_FILTERS: DiagramFilters = {
  damages: true,
  service: true,
  suggestions: true,
  dimensions: false,
};

export function useDiagramFilters() {
  const [filters, setFilters] = useState<DiagramFilters>(DEFAULT_FILTERS);

  const toggleFilter = useCallback((key: keyof DiagramFilters) => {
    setFilters((prev) => ({...prev, [key]: !prev[key]}));
  }, []);

  return {filters, toggleFilter};
}
